const APP_INDEX = 'guests/';

export default {
  namespaced: true,
  state: {
    guests: {
      data: [],
      current_page: 0,
      last_page: 0,
      total: 0
    },
  },
  getters: {
    getGuests: (state) => {
      return state.guests.data;
    },
    getCurrentPage: (state) => {
      return state.guests.current_page;
    },
    getLastPage: (state) => {
      return state.guests.last_page;
    },
    getTotalRestaurants: (state) => {
      return state.guests.total
    },
    isLastPage : (state) => {
      return state.guests.last_page == state.guests.current_page;
    }
  },
  mutations: {
    resetResults: (state, payload) => {
      return new Promise(resolve => {
        state.guests.data = [];
        state.guests.current_page = 0;
        state.guests.last_page = 0;
        state.guests.total = 0;
        resolve();
      })

    },
  },
  actions: {
    getGuest(store, payload){
      return new Promise((resolve, reject) => {
        if(!payload.id){
          return;
        }

        axios.get(APP_INDEX+payload.id)
          .then(({data}) => {
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      });
    },
    update(store, payload){
      return new Promise((resolve, reject) => {
         let method = 'put';
         let url = APP_INDEX + payload.id

        axios[method](url, payload)
          .then(({data}) => {
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      });
    },
    loadGuests(store, payload) {
      return new Promise((resolve, reject) => {
        let data = {};
        data.page = payload.page;
        data.search = payload.search;
        return axios.get(APP_INDEX, {
          params: data,
        })
          .then(({data}) => {
            store.state.guests.data = data.data
            store.state.guests.current_page = data.meta.current_page
            store.state.guests.last_page = data.meta.last_page
            resolve(data);
          })
      });
    },
    resetResults(store,payload){
      return new Promise((resolve,reject) => {
        store.commit('resetResults');
        resolve();
      });
    }
  }
}
